import ModalFrame from './ModalFrame'

export default ModalFrame
